import { CommandRequestType } from "../../authentication/connection/commandRequestType";
import { ErrorDetails, PassengerDriversResponseDto } from "../../authentication/connection/interfaces/apiInterfaces";
import { IRequestCommand } from "../../authentication/connection/iRequestCommand";

export class getPassengerDriversCommand extends IRequestCommand<PassengerDriversResponseDto[], ErrorDetails, IPassengerDrivers> {
  override _commandType: CommandRequestType = CommandRequestType.GET;

  public override setParameters(parameters: IPassengerDrivers) {
    this.urlSections.push('passengers');
    this.urlSections.push(parameters.passengerUserId.toString());
    this.urlSections.push('driverPreference')
    this.urlSections.push('carrier');
    this.urlSections.push(`${parameters.carrierId}`);
    this.composeUrl();
  }
}

export interface IPassengerDrivers {
  carrierId: number;
  passengerUserId: number;
}